import React from 'react';

const RoadmapToResults = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-16">
      <div className="flex flex-col lg:flex-row">
        {/* Left section with heading and text */}
        <div className="lg:w-1/3 mb-8 lg:mb-0 pr-0 lg:pr-8">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Roadmap to{' '}
            <span className="text-blue-500">Results</span>
          </h2>
          <p className="text-gray-700 mb-8">
            Our process is a journey of discovery, collaboration, and innovation. We work with our clients to understand their needs and their problems. Then, we create special solutions to help them reach their goals.
          </p>
          <button className="border-2 border-indigo-700 text-indigo-700 px-6 py-3 inline-flex items-center font-medium">
            Book A Meeting
            <svg className="ml-2 w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </button>
        </div>

        {/* Right section with cards grid */}
        <div className="lg:w-2/3 grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Card 1 */}
          <div className="border border-gray-200 bg-white rounded-md p-6 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-16 h-16">
              <div className="bg-blue-500 w-full h-8"></div>
              <div className="bg-blue-700 w-full h-8"></div>
              <div className="bg-yellow-400 w-full h-8 transform rotate-45 translate-y-4 translate-x-4"></div>
            </div>
            <div className="mb-4 text-indigo-700">
              <svg className="w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-3">Uncovering Your Vision</h3>
            <p className="text-gray-700">
              At 24-7 Consultancy, we're passionate about helping businesses succeed. That's why we start by deeply understanding your unique needs and challenges.
            </p>
          </div>

          {/* Card 2 */}
          <div className="border border-gray-200 bg-white rounded-md p-6 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-16 h-16">
              <div className="bg-blue-500 w-full h-8"></div>
              <div className="bg-blue-700 w-full h-8"></div>
              <div className="bg-yellow-400 w-full h-8 transform rotate-45 translate-y-4 translate-x-4"></div>
            </div>
            <div className="mb-4 text-indigo-700">
              <svg className="w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-3">Crafting Solutions</h3>
            <p className="text-gray-700">
              Our team of experts will carefully learn about your business needs and goals. After that, we'll explore various ideas and options to find the best solutions.
            </p>
          </div>

          {/* Card 3 */}
          <div className="border border-gray-200 bg-white rounded-md p-6 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-16 h-16">
              <div className="bg-blue-500 w-full h-8"></div>
              <div className="bg-blue-700 w-full h-8"></div>
              <div className="bg-yellow-400 w-full h-8 transform rotate-45 translate-y-4 translate-x-4"></div>
            </div>
            <div className="mb-4 text-indigo-700">
              <svg className="w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-3">Delivering Success</h3>
            <p className="text-gray-700">
              At 24-7 Consultancy, the magic happens in the development and implementation phase. This is where we take your vision and turn it into a reality.
            </p>
          </div>

          {/* Card 4 */}
          <div className="border border-gray-200 bg-white rounded-md p-6 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-16 h-16">
              <div className="bg-blue-500 w-full h-8"></div>
              <div className="bg-blue-700 w-full h-8"></div>
              <div className="bg-yellow-400 w-full h-8 transform rotate-45 translate-y-4 translate-x-4"></div>
            </div>
            <div className="mb-4 text-indigo-700">
              <svg className="w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-3">Empowering Innovation</h3>
            <p className="text-gray-700">
              Encourage a culture of innovation where employees are empowered to propose new ideas and solutions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoadmapToResults;